export default function toDegrees(value?: string | number) {
  return `${value || 0}°`
}
